import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
import { API_URL } from "@/common/config";

import store from "@/store";

export const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        Vue.axios.defaults.baseURL = API_URL;
        Vue.axios.defaults.withCredentials = true;
        Vue.axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': window.csrfTokenValue,
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
        };
    },

    query(resource, params) {
        return Vue.axios.get(resource, params)
        .catch(error => {
            throw new Error(`ApiService ${error}`);
        });
    },

    get(resource, slug = "", useLanguage = true) {
        let requestPath = resource;
        requestPath += slug ? `/${slug}` : '';

        let headers = {};

        const token = store.getters['authentication/getToken'];
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }

        return Vue.axios.get(requestPath, {
            headers,
            params: {
                // language
            }
        });
    },

    post(resource, params) {
        var bodyFormData = new FormData();
        bodyFormData.set('payload', JSON.stringify(params));

        return Vue.axios.post(`${resource}`, bodyFormData);
    },

    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params);
    },

    login(params) {

        return Vue.axios.post('/', qs.stringify(params), {
            baseURL: '',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
        });
    },

    logout() {

        return Vue.axios.get('/logout', {
            baseURL: '',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
            },
        });
    },

    postBase(params) {

        const headers = {};
        if (localStorage.getItem('token')) {
            headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
        }

        return Vue.axios.post('/', qs.stringify(params), {
            baseURL: `/${window.siteHandle}/`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json',
                ...headers
            },
        });
    },
};
